module.exports = __webpack_public_path__ + "static/img/bg-ar.d145c09d.png";